import { useCallback, useContext } from 'react';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { getIsNodeFile } from 'utils';
import ShareableLinkFileDownloadContext from '../providers/ShareableLinkFileDownload/ShareableLinkFileDownload.context';
import useStartDownloadingFile from './useStartDownloadingFile';

export default function useFileDownload(
  shareableLinkId: string,
  baseLevelNodes?: DataRoomNode[],
) {
  const { openDownloadModal } = useContext(ShareableLinkFileDownloadContext);

  const startDownloadingFile = useStartDownloadingFile();

  const download = useCallback(
    (nodes: DataRoomNode[]) => {
      if (nodes.length === 1 && getIsNodeFile(nodes[0])) {
        startDownloadingFile(shareableLinkId, nodes[0]._id);
      } else {
        openDownloadModal(shareableLinkId, nodes, baseLevelNodes);
      }
    },
    [shareableLinkId, baseLevelNodes, openDownloadModal, startDownloadingFile],
  );

  return { download };
}
